import React from 'react'
import Navbar from '../components/Navbar'
import image from './../images/Launch Call to Action Section.png'
import Footer from '../components/Footer'

function Careers() {
    return (
        <main className="main" id="top">
            <Navbar />
            <section className="position-relative vw-100" style={{height: 400}} id="home">
                <div className="position-absolute w-100 h-100" style={{backgroundImage: `url('${image}')`, backgroundPosition: "top", backgroundSize: "cover", backgroundRepeat: "no-repeat",  top: 0, left: 0, zIndex: -1, filter: "brightness(0.35)"}}>
                </div>
            </section>
            <section className="position-relative p-lg-3" id="faqs">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-md-12 col-lg-8 mt-6">
                            <h3 className="text-muted text-center">No Vacancy Available</h3>
                            <p className="text-secondary text-center">Please check back later for new opportunities.</p>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </main>
    )
}

export default Careers
